import Vue from 'vue'
import axios from 'axios/index'
import { processAthlete } from '@/store/modules/athletes/detail'

// state
export const state = {
  isPicksLoading: false,
  picks: {},
}

// getters
export const getters = {
  getFriendPicks: ({ picks }) => ({ friendId }) => picks[friendId] || null,
}
// mutations
export const mutations = {
  fetchPicksStart(state) {
    state.isPicksLoading = true
  },
  fetchPicksSuccess(state, { picks, userId }) {
    state.isPicksLoading = false
    picks = picks.map((pick) => {
      return {
        ...pick,
        athletes: pick.athletes
          .sort(({ round_score: scoreA }, { round_score: scoreB }) => {
            if (scoreB < scoreA) { return -1 }
            if (scoreB > scoreA) { return 1 }
            return 0
          })
          .map((athlete) => {
            return {
              athlete: processAthlete(athlete),
            }
          }),
      }
    })
    Vue.set(state.picks, userId, picks)
  },
  fetchPicksFailed(state) {
    state.isPicksLoading = false
  },
}
// actions
export const actions = {
  async fetchPicks({ commit, getters }, { userId }) {
    const cachedFriendPicks = getters.getFriendPicks({ friendId: userId })
    if (cachedFriendPicks) {
      return cachedFriendPicks
    }
    try {
      commit('fetchPicksStart')
      const picks = await axios.get(`predictions/${userId}`)
      commit('fetchPicksSuccess', {
        picks,
        userId,
      })
    } catch (err) {
      commit('fetchPicksFailed')
    }
    return false
  },
}
